var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009543",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ed4135",
    d: "M.3 0h53.4v26.7H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035ad",
    d: "M.3 0h53.4v13.3H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fae600",
    stroke: "#000",
    strokeWidth: 0.7,
    d: "M20.3 33.1a13.1 13.1 0 1 0 0-26.2 13.1 13.1 0 0 0 0 26.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.1 22h4.4Zm0-3.3h4.4Zm2.2-11.8v22.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.8,
    d: "M18.1 22h4.4m-4.4-3.3h4.4M20.4 6.9v22.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M15 32c5.4 2.2 10.4.2 10.4.2l-2.8-2.9c-1-.8-3.8-.7-4.7 0zm5.3-3.8q1.4-.2 1.5-2.2-.1-1.8-1.5-2-1.3.2-1.4 2 .1 2 1.4 2.2m0-6.8q1.7-.1 1.8-1-.2-1.1-1.8-1.2-1.6.1-1.7 1.1.2 1 1.7 1.1m0-4.5a1.8 1.8 0 1 0 0-3.6 1.8 1.8 0 0 0 0 3.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m22.5 8.5-.2.8c-1.6 2.8-3.1 2.9-3.4 3.1l-.5.3v-1.3c.3-1.3 2.3-1.3 3.8-2.7zm-5.2 6 .4 2c0 1.6 1.6 1.6 2.6 1.6v-.9c-.8 0-1.4 0-2-1.2zm0 12.9 1.1-2.3q.7-1.4 2-1.4v-1.2q-2.7 0-2.6 1.5-.2 1.8-.6 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.4 14.5s-.4 1-.4 2c0 1.6-1.6 1.6-2.7 1.6v-.9c.8 0 1.5 0 2-1.2zm0 12.9-1.2-2.3a2 2 0 0 0-1.9-1.4v-1.2q2.5 0 2.6 1.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNc);
export default __webpack_public_path__ + "static/media/nc.9d504ea59d4025d1d14b5f6a5c043d04.svg";
export { ForwardRef as ReactComponent };